import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
}

export const getters = {}

export const mutations = {
  SET_TIPS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
    // // console.log(state.objects)
  },
  SET_TIP(state, objects) {
    state.currentDepot = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getTips({ commit }) {
    try {
      return await graphqlClient.query({
        query: gql`
          query getTips{
            tiplocations{
              id
              address
              suburb
              state
              country
              postcode
              location_type
              lat
              lon
              price
              name
              created_at
              updated_at
              deleted_at
            }
          }
        `,
      }).then((result) => {
        // // console.log(result)
        commit('SET_TIPS', result.data.tiplocations)
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  // async getTipById({ commit }, { id } = {}) {
  //   try {
  //     return await graphqlClient.query({
  //       query: gql`
  //                 query getDepotById($Id: ID!) {
  //                   getDepotById(id: $Id) {
  //                     id
  //                     address
  //                     suburb
  //                     state
  //                     country
  //                     postcode
  //                     location_type
  //                     lat
  //                     lon
  //                     created_at
  //                     updated_at
  //                     deleted_at
  //                   }
  //                 }
  //               `,
  //       variables:{ Id: id }
  //     }).then((response) => {
  //       // console.log(response)
  //       // commit('SET_TIP', response.data.getDepotById)
  //       // return response.data.getDepotById;
  //     })
  //   } catch (ex) {
  //     console.error(ex)
  //     throw ex
  //   }
  // },

  async createTip ({ commit, dispatch }, { address, suburb, state, country, postcode, name, price } = {}) {
    try {
      return await graphqlClient.mutate({
        mutation: gql`
          mutation createTip($Address: String $Suburb: String $State: String $Country: String $Postcode: Int $Name: String $Price: Int)  {
            createTipLocation(
            site:{
              address: $Address
              suburb: $Suburb
              state: $State
              country: $Country
              postcode: $Postcode    
              name: $Name                        
              price: $Price                        
            }) 
            {
              id
            }
          }
          `,
        variables: {Address: address, Suburb: suburb, State: state, Country: country, Postcode: postcode, Name: name, Price: price}
      }).then((response) => {
        // console.log(response)
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async deleteTip({ commit, dispatch }, {id} = {}) {
    try {
      return await graphqlClient.mutate({
        mutation: gql`
            mutation deleteTip($Id: Int)  {
              deleteTipLocation(id: $Id) {
                id
              }
            }
        `,
        variables: {Id: id},
      }).then((response) => {
        // // console.log(response)
        // commit('SET_DEPOTS', response.data.deleteDepot)
        dispatch('getTips')
        return response
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateTip({ commit, dispatch }, { id, address, suburb, state, country, postcode, name, price} = {}) {
    try {
      return await graphqlClient.mutate({
        mutation: gql`
            mutation updateTip($Id:Int! $Address: String $Suburb: String $State: String $Country: String $Postcode: Int $Name: String $Price: Int)  {
              updateTipLocation(
                id: $Id 
                site:{
                  address: $Address
                  suburb: $Suburb
                  state: $State
                  country: $Country
                  postcode: $Postcode    
                  name: $Name  
                  price: $Price     
                }
              ) 
              {
                id
              }
            }
            `,
        variables: {Id: id, Address: address, Suburb: suburb, State: state, Country: country, Postcode: postcode, Name: name, Price: price}
      }).then((response) => {
        // console.log(response)
        // commit('SET_DEPOTS', response.data.depots)
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
}
